import { isNative } from "@/lib/platform";

/**
 * OTA (live update) — вэб bundle-ыг дэлгүүрийн хяналтгүйгээр шинэчлэх давхарга.
 *
 * ⚠ ЯАГААД ЭНЭ ФАЙЛ ЗААВАЛ ХЭРЭГТЭЙ ВЭ:
 * `@capgo/capacitor-updater` нь шинэ bundle ачаалахдаа "апп зөв эхэлсэн үү"
 * гэдгийг `notifyAppReady()` дуудлагаар хүлээж мэднэ. `appReadyTimeout`
 * (анхны утга 10 сек) дотор дуудагдахгүй бол плагин уг bundle-ыг ЭВДЭРСЭН гэж
 * үзээд ӨМНӨХ хувилбар руу автоматаар буцаана.
 *
 * Энэ бол санаатай хамгаалалт: алдаатай OTA гаргавал хэрэглэгчийн апп тоосго
 * болохгүй, өөрөө сэргэнэ. Гэхдээ эсрэгээрээ — дуудлагыг МАРТВАЛ бүх OTA
 * шинэчлэлт чимээгүйхэн буцаагдаж, "яагаад шинэчлэлт суухгүй байна вэ" гэсэн
 * ойлгоход хэцүү алдаа үүснэ. Тиймээс index.js-д хамгийн эхэнд дуудна.
 *
 * ⚠ ВЭБ ХУВИЛБАРТ НӨЛӨӨЛӨХГҮЙ:
 * plugin-ийг ДИНАМИКААР import хийсэн тул тусдаа chunk болж, вэб хэрэглэгч
 * татахгүй. `isNative()` худал үед энэ функц шууд буцна.
 */
export const notifyAppReady = async () => {
    if (!isNative()) return { ok: false, reason: "not-native" };
    try {
        const { CapacitorUpdater } = await import("@capgo/capacitor-updater");
        await CapacitorUpdater.notifyAppReady();
        return { ok: true };
    } catch (e) {
        // Плагин суугаагүй эсвэл native тал бэлэн биш — апп үргэлжлүүлж ажиллана.
        // Энд алдаа шидвэл апп огт нээгдэхгүй болно, тэр нь хамаагүй дор.
        console.warn("OTA notifyAppReady амжилтгүй:", e?.message ?? e);
        return { ok: false, reason: "plugin-error" };
    }
};

/**
 * Одоо ажиллаж буй bundle-ийн мэдээлэл (дэмжлэг/оношилгоонд).
 * `version` нь OTA bundle-ийн хувилбар — native аппын хувилбартай ӨӨР байж болно.
 */
export const getCurrentBundle = async () => {
    if (!isNative()) return null;
    try {
        const { CapacitorUpdater } = await import("@capgo/capacitor-updater");
        return await CapacitorUpdater.current();
    } catch (e) {
        return null;
    }
};
